import React, {FC, useState} from "react"

import GenericModal from "@irati/ui/src/GenericModal"
import {H3, Body} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage, injectIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import mainTheme from "@irati/ui/src/global/theme"
import Loading from "@irati/ui/src/Loading"
import tracking from "@irati-tracking/wallet/rewardPointsWallet"
import {TopUpPayload} from "../../../containers/AdminReward/AdminRewardTopUp"

interface Props {
  confirmedTandC: boolean
  payload: TopUpPayload
  topupAmount: number
  setShowDialogModal: (value: boolean) => void
  setShowConfirmationModal: (value: boolean) => void
  createTopUp: () => Promise<void>
}

const DialogueModal: FC<Props> = ({confirmedTandC, payload, topupAmount, setShowDialogModal, setShowConfirmationModal, createTopUp}) => {
  const [load, setLoad] = useState<Promise<any> | null>(null)

  const closeCompletionModal = () => {
    setShowDialogModal(false)
  }

  const onSuccess = () => {
    tracking.bankTransfer()
    const loader = createTopUp().then(() => {
      tracking.bankTransferSuccess()
      closeCompletionModal()
      setShowConfirmationModal(true)
    })

    setLoad(loader)
  }

  return (
    <GenericModal hideActions show={confirmedTandC} onHide={closeCompletionModal}>
      <H3>
        <FormattedMessage id="wallet.reward.checkout.bankTransfer.dialogue.title" />
      </H3>
      <Body marginTop={3} marginBottom={3} color={mainTheme.colors.greys.black}>
        <FormattedMessage
          id="wallet.reward.checkout.bankTransfer.dialogue.contentOne"
          values={{
            totalToPay: <FormattedCurrency currency={payload.purchaseCurrency} value={topupAmount} />,
            amountValue: payload.rpPoints,
            amountTitle: <FormattedMessage id="wallet.reward.admin.confirmationModal.points" />
          }}
        />
      </Body>
      <Body marginBottom={3} color={mainTheme.colors.greys.black}>
        <FormattedMessage id="wallet.reward.checkout.bankTransfer.dialogue.contentTwo" />
      </Body>

      <div>
        <Loading load={load} useLoader={false} />
      </div>

      <Button id="rewardWallet_topUp_modal_bank_requestInvoice_button" primary marginRight onClick={onSuccess}>
        <FormattedMessage id="wallet.tenant.topUp.confirmationPopup.button.bank" />
      </Button>
      <Button id="rewardWallet_topUp_modal_bank_goBack_button" onClick={closeCompletionModal}>
        <FormattedMessage id="platform.button.goBack" />
      </Button>
    </GenericModal>
  )
}

export default injectIntl(DialogueModal)
